import { render } from "./MenuLang.vue?vue&type=template&id=980e9c98&scoped=true"
import script from "./MenuLang.vue?vue&type=script&lang=js"
export * from "./MenuLang.vue?vue&type=script&lang=js"

import "./MenuLang.vue?vue&type=style&index=0&id=980e9c98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-980e9c98"]])

export default __exports__